import { render, staticRenderFns } from "./InsightBarChart.vue?vue&type=template&id=7fe4e6ae&scoped=true&"
import script from "./InsightBarChart.vue?vue&type=script&lang=js&"
export * from "./InsightBarChart.vue?vue&type=script&lang=js&"
import style0 from "./InsightBarChart.vue?vue&type=style&index=0&id=7fe4e6ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe4e6ae",
  null
  
)

export default component.exports